
import PropTypes from "prop-types";
import { Typography, TextField } from "@mui/material";


function Postcode({
  label,
  inputLabel,
  formState,
  setFormState,
  setFormError,
}) {
  function onChange(e) {
    const inputValue = e.target.value.toUpperCase();
    const alphanumericRegex = /^[a-z0-9]+$/i;

    if (alphanumericRegex.test(inputValue) || inputValue === "") {
      setFormState((prev) => ({
        ...prev,
        postcode: inputValue,
      }));
      setFormError(null);
    }
  }

  return (
    <>
      <Typography
        id='postcodeLabel'
        component='label'
        htmlFor='postcodeInput'
        sx={{
          fontWeight: "bold"
        }}
      >
        {label}
      </Typography>
      <TextField
        id='postcodeInput'
        margin='dense'
        required
        fullWidth
        label={inputLabel}
        name='postcode'
        onChange={onChange}
        value={formState.postcode || ""}
      />
    </>
  );
};

const validatePostcode = (postcode) => {
  const postcodeRegex = /^([A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2})$/i;
  return postcodeRegex.test(postcode);
};

Postcode.propTypes = {
  label: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  setFormError: PropTypes.func.isRequired,
};

export { Postcode, validatePostcode };
